// extracted by mini-css-extract-plugin
export default {"containerParagraph":"Welcome-module--containerParagraph--DZwVn"};